import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { Form } from "@/lib/formable";
import { MrfiktivInsuranceRateViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
export class InsuranceContractRateBase implements MrfiktivInsuranceRateViewModelGen {
  @FilterConfig({ type: FilterTypes.BOOLEAN, displayName: "objects.contract.insurance.hasGapCoverage" })
  hasGapCoverage?: boolean | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.fullComprehensiveDeductible" })
  fullComprehensiveDeductible?: number | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.partialCoverageDeductible" })
  partialCoverageDeductible?: number | null;

  @FilterConfig({ type: FilterTypes.BOOLEAN, displayName: "objects.contract.insurance.hasRoadsideAssistance" })
  hasRoadsideAssistance?: boolean | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.maxTowingAmount" })
  maxTowingAmount?: number | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.maxRoadsideCoverageAmount" })
  maxRoadsideCoverageAmount?: number | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.rentalCarDailyRate" })
  rentalCarDailyRate?: number | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.rentalCarMaxDays" })
  rentalCarMaxDays?: number | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.insurance.maxBreakdownAssistanceAmount" })
  maxBreakdownAssistanceAmount?: number | null;

  constructor(data?: Partial<MrfiktivInsuranceRateViewModelGen>) {
    this.hasGapCoverage = data?.hasGapCoverage;
    this.fullComprehensiveDeductible = data?.fullComprehensiveDeductible;
    this.partialCoverageDeductible = data?.partialCoverageDeductible;
    this.hasRoadsideAssistance = data?.hasRoadsideAssistance;
    this.maxTowingAmount = data?.maxTowingAmount;
    this.maxRoadsideCoverageAmount = data?.maxRoadsideCoverageAmount;
    this.rentalCarDailyRate = data?.rentalCarDailyRate;
    this.rentalCarMaxDays = data?.rentalCarMaxDays;
    this.maxBreakdownAssistanceAmount = data?.maxBreakdownAssistanceAmount;
  }

  map(data: MrfiktivInsuranceRateViewModelGen): void {
    this.hasGapCoverage = data?.hasGapCoverage;
    this.fullComprehensiveDeductible = data?.fullComprehensiveDeductible;
    this.partialCoverageDeductible = data?.partialCoverageDeductible;
    this.hasRoadsideAssistance = data?.hasRoadsideAssistance;
    this.maxTowingAmount = data?.maxTowingAmount;
    this.maxRoadsideCoverageAmount = data?.maxRoadsideCoverageAmount;
    this.rentalCarDailyRate = data?.rentalCarDailyRate;
    this.rentalCarMaxDays = data?.rentalCarMaxDays;
    this.maxBreakdownAssistanceAmount = data?.maxBreakdownAssistanceAmount;
  }

  get fullComprehensiveDeductibleFormable(): number | null | undefined {
    if (this.fullComprehensiveDeductible === null || this.fullComprehensiveDeductible === undefined) {
      return null;
    }
    return this.fullComprehensiveDeductible;
  }
  set fullComprehensiveDeductibleFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.fullComprehensiveDeductible = null;
    } else {
      this.fullComprehensiveDeductible = Number(v);
    }
  }

  get partialCoverageDeductibleFormable(): number | null | undefined {
    if (this.partialCoverageDeductible === null || this.partialCoverageDeductible === undefined) {
      return null;
    }
    return this.partialCoverageDeductible;
  }
  set partialCoverageDeductibleFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.partialCoverageDeductible = null;
    } else {
      this.partialCoverageDeductible = Number(v);
    }
  }

  get maxTowingAmountFormable(): number | null | undefined {
    if (this.maxTowingAmount === null || this.maxTowingAmount === undefined) {
      return null;
    }
    return this.maxTowingAmount;
  }
  set maxTowingAmountFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.maxTowingAmount = null;
    } else {
      this.maxTowingAmount = Number(v);
    }
  }

  get maxRoadsideCoverageAmountFormable(): number | null | undefined {
    if (this.maxRoadsideCoverageAmount === null || this.maxRoadsideCoverageAmount === undefined) {
      return null;
    }
    return this.maxRoadsideCoverageAmount;
  }
  set maxRoadsideCoverageAmountFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.maxRoadsideCoverageAmount = null;
    } else {
      this.maxRoadsideCoverageAmount = Number(v);
    }
  }

  get rentalCarDailyRateFormable(): number | null | undefined {
    if (this.rentalCarDailyRate === null || this.rentalCarDailyRate === undefined) {
      return null;
    }
    return this.rentalCarDailyRate;
  }
  set rentalCarDailyRateFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.rentalCarDailyRate = null;
    } else {
      this.rentalCarDailyRate = Number(v);
    }
  }

  get rentalCarMaxDaysFormable(): number | null | undefined {
    if (this.rentalCarMaxDays === null || this.rentalCarMaxDays === undefined) {
      return null;
    }
    return this.rentalCarMaxDays;
  }
  set rentalCarMaxDaysFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.rentalCarMaxDays = null;
    } else {
      this.rentalCarMaxDays = Number(v);
    }
  }

  get maxBreakdownAssistanceAmountFormable(): number | null | undefined {
    if (this.maxBreakdownAssistanceAmount === null || this.maxBreakdownAssistanceAmount === undefined) {
      return null;
    }
    return this.maxBreakdownAssistanceAmount;
  }
  set maxBreakdownAssistanceAmountFormable(v: number | null | undefined) {
    if (v === null || v === undefined || `${v}` === "") {
      this.maxBreakdownAssistanceAmount = null;
    } else {
      this.maxBreakdownAssistanceAmount = Number(v);
    }
  }
}

type IInsuranceContractRate = InsuranceContractRateBase;
const InsuranceContractRate = Filter.createForClass(Form.createForClass(InsuranceContractRateBase));

export { IInsuranceContractRate, InsuranceContractRate };
